// Libraries
import styled, { css } from 'styled-components'
import { motion } from 'framer-motion'

// Components
import { Hr as SHr } from '../Footer/style'

export const Wrap = styled.div`
  width: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  z-index: 101;
`;

export const HeaderLogo = styled(motion.img)`
  width: 212px;
  height: 100px;
  align-self: center;
  :hover {
    cursor: pointer;
  }
`;

export const Hr = styled(SHr)`
  margin: 0 auto;
  ${({ theme }) => css`
    ${theme.media.mobileL} {
      display: none;
    }
  `}
`;

export const HrMobile = styled(Hr)`
  display: none;
  ${({ theme }) => css`
    ${theme.media.mobileL} {
      display: block;
    }
  `}
`;
